<template>
  <v-select
    v-model="selectedRole"
    :readonly="roleItems.length === 1"
    :items="roleItems"
    item-text="label"
    item-value="id"
    label="Active Role"
    dense
    outlined
    hide-details
    return-object
    color="#ec9436"
    @change="updateUserRole"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Role } from "@/enums";

export default {
  name: "HeaderActiveRoleSelect",
  data() {
    return {
      selectedRole: null,
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "userRole",
      userActiveRole: "userActiveRole",
    }),
    roleItems() {
      const roleList = Role.codeToLabels(this.userRole);
      return roleList.map((roleLabel) => {
        const roleCode = Role.labelToCode(roleLabel);
        return {
          label: roleLabel,
          id: roleCode,
        };
      });
    },
  },
  watch: {
    userActiveRole(newRole) {
      if (newRole !== this.selectedRole) this.selectedRole = newRole.role;
    },
  },
  created() {
    this.selectedRole = this.userActiveRole.role;
  },
  methods: {
    ...mapActions("user", {
      setUserActiveRole: "setUserActiveRole",
    }),

    updateUserRole() {
      if (this.selectedRole) {
        this.setUserActiveRole(this.selectedRole.id);
      }
    },
  },
};
</script>
